





















import { defineComponent, ref } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { ProductForProductPageType } from '~/utils/types/ProductPage';
import { productPeriodicityToggleTrack } from '~/helpers/trackings/24orepro/products';

export default defineComponent({
    props:{
        changeFrequencyFn:{
            type: Function,/** must have 1 parameter (frequency) */
            required: true
        },
        product: {
            type: Object as PropType<ProductForProductPageType>,
            required: true
        }        
    },
    setup(props) {
        const { product, changeFrequencyFn } = props;
        const lowFrequency = product.paymentFrequencies[0];
        const highFrequency = product.paymentFrequencies[1];
        const hasFrequencies = lowFrequency != highFrequency && !!highFrequency;
        const selectedFrequency = ref(product.entryBillingPeriod ?? lowFrequency);
        try{changeFrequencyFn(selectedFrequency.value)}catch(e){/** probably the product has not tipo_abbonamento */}
        
        return {
            hasFrequencies,
            lowFrequency,
            highFrequency,
            selectedFrequency,
        }
    },
    mounted(){
        this.$emit('mounted', this.hasFrequencies)
    },
    methods:{
        changeFrequency() {
            const frequency = this.selectedFrequency == this.lowFrequency ? this.highFrequency : this.lowFrequency
            this.selectedFrequency = frequency;
            this.changeFrequencyFn(frequency)
            productPeriodicityToggleTrack(this.product, this.selectedFrequency)
        }
    }
})
